import React from 'react';
import { useIsDesktop } from '@/hooks/useMediaQuery';
import { SettingsPageDesktop } from './SettingsPage.Desktop';
import { SettingsPageMobile } from './SettingsPage.Mobile';

/**
 * Main Settings Page component that switches between desktop and mobile layouts.
 * Uses screen width detection to determine which version to render.
 */
export const SettingsPage: React.FC = () => {
  const isDesktop = useIsDesktop();

  if (isDesktop) {
    return <SettingsPageDesktop />;
  }

  return <SettingsPageMobile />;
};
